import { useEffect, useState } from "react"

export const useBlobText = (blob) => {
  const [text, setText] = useState(null)

  useEffect(() => {
    let current = true
    blob?.text().then((value) => current && setText(value))

    return () => {
      current = false
    }
  }, [blob])

  return text
}
